import React, { useEffect, useRef } from "react";
import "./NewCheckbox.scss";

interface NewCheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  indeterminate?: boolean;
  className?: string;
  name?: string;
  id?: string;
  checkedBgColor?: string;
  color?: string;
  labelTitle?: string;
}

const NewCheckbox: React.FC<NewCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
  indeterminate = false,
  className = "",
  name,
  id,
  checkedBgColor,
  color,
  labelTitle,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  const checkboxBoxStyle =
    checked && checkedBgColor
      ? { background: checkedBgColor, borderColor: checkedBgColor }
      : undefined;

  const labelStyle = color ? { color } : undefined;

  return (
    <label
      htmlFor={id}
      className={`new-checkbox-root ${className} ${disabled ? "disabled" : ""}`}
    >
      <input
        ref={inputRef}
        type="checkbox"
        className="new-checkbox-input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
        name={name}
        id={id}
      />
      <span
        className={`new-checkbox-box ${checked ? "checked" : ""} ${
          indeterminate && !checked ? "indeterminate" : ""
        }`}
        style={checkboxBoxStyle}
      ></span>
      {label && (
        <span
          className="new-checkbox-label"
          style={labelStyle}
          title={labelTitle}
        >
          {label}
        </span>
      )}
    </label>
  );
};

export default NewCheckbox;
